import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

export const PickersUtilsProvider = ({ children }) => (
  <MuiPickersUtilsProvider utils={MomentUtils} libInstance={moment}>
    {children}
  </MuiPickersUtilsProvider>
);

PickersUtilsProvider.propTypes = {
  children: PropTypes.node
};

export default PickersUtilsProvider;
